import { ReactNode } from 'react';
import styled from 'styled-components';
import { PopoverBody, UncontrolledPopover } from 'reactstrap';
import { NEGATIVE_SIGN } from '@paradigm/utils/src/enhanceNegativeSign';
import { mirage } from '@paradigm/design-system/src/colors';

interface Props {
  readonly children: ReactNode | null;
  readonly id: string;
  readonly popoverValue: ReactNode;
  readonly isEmpty?: boolean;
  readonly shouldDisplayPopover?: boolean;
  readonly ariaLabel?: string;
}

export default function PopoverCell({
  children,
  id,
  isEmpty = false,
  shouldDisplayPopover = true,
  popoverValue,
  ariaLabel,
}: Props) {
  if (children == null || isEmpty)
    return <span aria-label={ariaLabel}>{NEGATIVE_SIGN}</span>;
  if (!shouldDisplayPopover)
    return <span aria-label={ariaLabel}>{children}</span>;

  return (
    <Container aria-label={ariaLabel}>
      <ClampSpan id={id}>{children}</ClampSpan>
      <UncontrolledPopover
        hideArrow
        placement="bottom-start"
        target={id}
        trigger="click hover focus"
      >
        <Popover>{popoverValue}</Popover>
      </UncontrolledPopover>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  align-items: center;
`;

const ClampSpan = styled.span`
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
`;

const Popover = styled(PopoverBody)`
  background: ${mirage};
  margin: -0.5rem 0;
  color: white;
  border-radius: 5px;
  padding: 5px;
`;
